import { RevealGroup, RevealItem } from "@/lib/motion";
import { Section, SectionHeading } from "./primitives";
import { SPECS } from "@/config/site";

export default function SpecsSection() {
  return (
    <Section id="specs">
      <SectionHeading
        eyebrow="Specifications"
        title="XVPR at a Glance"
        lead="The core technical parameters that define Xenovia Prime."
      />
      <RevealGroup className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-white/10 bg-white/[0.04] sm:grid-cols-2 lg:grid-cols-5">
        {SPECS.map((s, i) => (
          <RevealItem
            key={s.label}
            className="bg-[#050508]/60 p-6 transition-colors duration-500 hover:bg-white/[0.03]"
            data-testid={`spec-${i}`}
          >
            <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-indigo-400">
              {s.label}
            </div>
            <div className="mt-3 font-display text-sm font-bold uppercase leading-snug tracking-tight text-white">
              {s.value}
            </div>
          </RevealItem>
        ))}
      </RevealGroup>
    </Section>
  );
}
